import { render, staticRenderFns } from "./steps-bottom.vue?vue&type=template&id=6affed5d&scoped=true&"
import script from "./steps-bottom.vue?vue&type=script&lang=js&"
export * from "./steps-bottom.vue?vue&type=script&lang=js&"
import style0 from "./steps-bottom.vue?vue&type=style&index=0&id=6affed5d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6affed5d",
  null
  
)

export default component.exports